module.exports = "<div id=\"apiProviders\">\n    <div class=\"b-api__title\"><% print(lang(\"API Providers\")); %></div>\n</div>"